import script from "./LogoIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./LogoIcon.vue?vue&type=script&lang=ts&setup=true"

import "./LogoIcon.vue?vue&type=style&index=0&id=be36fa66&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be36fa66"]])

export default __exports__